export default "__VITE_ASSET__DaicL3dq__"